<template>
    <div class="actionLogVue">
        <div class="o-main-content-area">
            <div class="o-page-top-heading c-responsive-fixwidth">
                <div class="row c-responsive-fixwidth">
                    <div class="col-md-9">
                        <p class="u-back"><a href="javascript: void(0)" @click="back()"><i class="fa fa-chevron-left"></i> Back</a></p>
                    </div>
                    <div class="col-md-3">
                        <div class="input-group stylish-input-group" style="visibility:hidden;">
                            <input type="text" class="form-control" placeholder="Search">
                            <span class="input-group-addon">
                            <button type="submit">
                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                            </button>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row c-responsive-fixwidth">
                    <div class="col-md-12">
                        <h1 class="h1">Vacation Log</h1>
                        <h3 class="h3">{{getLogFor.logUser}}</h3>
                    </div>
                </div>
            </div>
        </div>

        <div class="o-ndividualArea c-responsive-fixwidth">
            <div 
                class="o-ndividualTable" 
                v-loading="loading" 
                infinite-scroll-disabled="busy" 
                infinite-scroll-distance="10"
                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                ref="scrollContainer"
                style="min-height: 1px;"
            >
                <div v-for="(vacation,index) in vacationLogList" :key="index" class="o-custom-table-container c-common-box-shadow c-radius3 actionLog-table-align o-overflow-visible">
                    <div class="o-calls-table c-common-gradient o-overflow-visible tableList-padding">
                        <div class="calls-table-row phonesheet-table-row">

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Initiator:</span>
                                        <div>{{vacation? vacation.initiator.first_name+" "+vacation.initiator.last_name:'--'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Affected User:</span>
                                        <div>{{vacation? vacation.affector.first_name+" "+vacation.affector.last_name:'--'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Timestamp:</span>
                                            <div>{{vacation? getGlobalDateTimeFormat(vacation.created_at):'--'}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Action:</span>
                                        <div>
                                            {{vacation ? vacation.status.name:'--'}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Start:</span>
                                        <div>{{vacation && vacation.vacation? getUserDateTimeFormat(vacation.vacation.start):'--'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>End:</span>
                                        <div>{{vacation && vacation.vacation ? getUserDateTimeFormat(vacation.vacation.end):'--'}}</div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>   
                <div v-if="afterApi && vacationLogList.length<=0" class="">
                    <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                        <div class="col-md-12 no-job-dispaly">
                            <i class="fa fa-frown-o" aria-hidden="true"></i>
                            <br />
                            No Data Stored
                        </div>
                    </div>
                </div>
                                  
            </div>          
        </div>       
    </div>
</template>

<script>
    import {
        VueEditor
    } from 'vue2-editor';
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';

    import { bus } from '../../main';
    import service from '../../services.js';

    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                vacationLogList: [],
                storeMore:'',
                next_page:null,
                loading:false,
                afterApi: false,
                userDateFormat: null,
                userTimeFormat: null,
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userRoleSlug: 'userRoleSlug',
                userClientID: 'userClientID',
                getLogFor: 'getLogFor',
                currentEmployeeID: 'currentEmployeeID',
                employeeId:'employeeId'                
            })
        },
        methods: {
            back(){
                this.$router.go(-1);
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },
            getDateForStatus(dateTime) {
                return moment(dateTime).format('DD MMM YYYY');
            },
            getTimeStamp(dateTime) {
                if (dateTime != 'undefined') {
                    return dateTimeConvert.utcTimeToUserTime(dateTime);
                }
            },
            getGlobalDateTimeFormat(data) {
                return dateTimeConvert.globalDateTime2(data,this.userDateFormat,this.userTimeFormat);
            },
            getUserDateTimeFormat(data) {
                return dateTimeConvert.getUserDateTime(data,this.userDateFormat,this.userTimeFormat);
            },
            getVacationLog(){
                this.loading=true;
                this.afterApi=false;
                service.get('vacation/getVacationLog', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userId': atob(this.$route.params.empId),
                }).then((res) => {
                    this.vacationLogList = res.data.result.data;
                    this.loading=false;
                    this.afterApi=true;
                    this.next_page = res.data.result.next_page_url;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'userId': atob(this.$route.params.empId)
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        })
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading=false;
                    this.afterApi=true;
                });
            },

            async handleScroll(position) {               
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                if (this.storeMore.length != 0) {
                    var arr = this.vacationLogList;
                    this.storeMore.forEach(function(data) {
                        arr.push(data);
                    });
                    this.storeMore=[];
                    if (this.next_page != null) {
                        await service.getUrl(this.next_page, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'userId': atob(this.$route.params.empId)
                            })
                            .then((res) => {
                                this.storeMore = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;
                            }).catch((err) => {
                                console.log(err);
                            })
                    } else {
                        this.storeMore = [];
                    }
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },
            async getEmpDetails() {
                await service.get('employee/' + this.getEmpId(), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.loading=false;
                    this.userDateFormat=res.data.result&&res.data.result.date_format?res.data.result.date_format:null;
                    this.userTimeFormat=res.data.result&&res.data.result.time_format?res.data.result.time_format:null;
                }).catch((err) => {
                    console.log(err);
                    this.loading=false;
                });
            },
            getEmpId() {
                return this.userRoleSlug&&this.userRoleSlug == 'client-admin' && this.currentEmployeeID ? this.currentEmployeeID : this.employeeId;
            }
        },
        created() {
            this.getVacationLog();
            this.getEmpDetails();
        },
        async beforeMount() {
            await this.getEmpDetails();
            bus.$on('onProfileUpdateOrAdd', async (data) => {
                await this.getEmpDetails();
            });
        },
    }

</script>
<style scoped>

.actionLog-table-align .calls-table-row .calls-table-cell:nth-child(3){
     width: 206px !important;
}
.actionLog-table-align .calls-table-row .calls-table-cell:nth-child(5){
     width: 206px !important;
}
.actionLog-table-align .calls-table-row .calls-table-cell:nth-child(6){
     width: 206px !important;
}
.actionLog-table-align .calls-table-row .calls-table-cell:first-child {
    width: 110px;
}
</style>
